import $ from 'zepto';
import './cookie.js';
import util from './util.js';
var times = 0;

export function login(url) {
	shouleiLogin('', function() {
		loginInit();
	}, true);
};

export function shouleiLogin(url, loginedFun, noreLoad) {
	try {
		var callback = JSON.stringify({
			"callback": "refreshAct"
		})
		window.share.goToLoginPageAndCallback(callback);
	} catch (e) {
		if (util.isShouLei()) {
			client.data.getUserInfo({
				"source": '',
				"forceLogin": 1
			}, function(rs) {
				if (rs.userInfo.userID) {
					window.SLUserInfo = rs;
					util.setShouLeiCookie(rs.userInfo);
				} else {
					window.SLUserInfo = null;
					util.clearShouLeiCookie();
				}
				if (typeof loginedFun == 'function') {
					loginedFun();
				}
				if (!noreLoad) { //异步的时候不要relaod,如果要reload写在function
					window.location.reload();
				}
			})
		} else {
			window.location.href = url || "http://act.vip.xunlei.com/waplogin/login.html?url=" + encodeURIComponent(location.href);
		}
	}
}
//调用退出
export function logout() {
	try {
		var callback = JSON.stringify({
			"callback": "xlQuickLogin.logout"
		});
		window.share.goToLogoutPageAndCallback(callback);
	} catch (e) {

	}
}
//判读是否登录
export function haslogin() {
	try {
		var userid = window.share.getUserId();
		if (userid <= 0) {
			return false;
		} else {
			return true;
		}

	} catch (e) {
		var sessionid = getCookie("sessionid");
		if (!sessionid || sessionid == '-1') {
			return false;
		}
		return true;
	}
}

window.haslogin = haslogin;
window.login = login;
window.logout = logout;



// WEBPACK FOOTER //
// ./src/common/login.js